import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { Check, ChevronRight } from 'lucide-react';
export function Hero() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    let particles: any[] = [];
    let animFrameId: number;
    const resize = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };
    const createParticle = () => ({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height,
      size: Math.random() * 2 + 0.5,
      speedX: (Math.random() - 0.5) * 0.3,
      speedY: (Math.random() - 0.5) * 0.3,
      opacity: Math.random() * 0.5 + 0.1,
      color: Math.random() > 0.5 ? '#D4AF37' : '#7C3AED',
      pulseSpeed: Math.random() * 0.02 + 0.005,
      pulseOffset: Math.random() * Math.PI * 2
    });
    const initParticlesArray = () => {
      const count = window.innerWidth < 768 ? 30 : 70;
      particles = Array.from({
        length: count
      }, createParticle);
    };
    const drawParticle = (p: any, time: number) => {
      const pulse = Math.sin(time * p.pulseSpeed + p.pulseOffset) * 0.3 + 0.7;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size * pulse, 0, Math.PI * 2);
      ctx.fillStyle = p.color;
      ctx.globalAlpha = p.opacity * pulse;
      ctx.fill();
      ctx.globalAlpha = 1;
    };
    const animate = (time: number) => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(p => {
        p.x += p.speedX;
        p.y += p.speedY;
        if (p.x < 0) p.x = canvas.width;
        if (p.x > canvas.width) p.x = 0;
        if (p.y < 0) p.y = canvas.height;
        if (p.y > canvas.height) p.y = 0;
        drawParticle(p, time * 0.001);
      });
      animFrameId = requestAnimationFrame(animate);
    };
    resize();
    initParticlesArray();
    animFrameId = requestAnimationFrame(animate);
    window.addEventListener('resize', () => {
      resize();
      initParticlesArray();
    });
    return () => cancelAnimationFrame(animFrameId);
  }, []);
  return <section className="relative min-h-screen flex items-center pt-24 pb-16 overflow-hidden bg-primary" id="inicio" data-id="element-144" data-mp="ibypabmmn01n">
      {/* Background Gradients */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_70%_50%,rgba(124,58,237,0.12)_0%,transparent_60%),radial-gradient(ellipse_at_20%_80%,rgba(212,175,55,0.08)_0%,transparent_50%)] pointer-events-none" data-id="element-145" data-mp="deyke41ik3c4" />
      
      <canvas ref={canvasRef} className="absolute inset-0 w-full h-full pointer-events-none z-0" data-id="element-146" data-mp="112pwb6j56ecv" />

      <div className="max-w-[1100px] mx-auto px-5 w-full relative z-10" data-id="element-147" data-mp="x14ohzlgsq9j">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center" data-id="element-148" data-mp="x0uywd4c0l4d">
          
          {/* Left Content */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-149" data-mp="3hrdbj1m0nm32">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} className="inline-flex items-center gap-2 bg-gold/10 border border-gold/30 rounded-full px-4 py-1.5 text-xs font-semibold text-gold tracking-widest uppercase mb-6" data-id="element-150" data-mp="1x9b5n20k33d3">
              <span className="w-1.5 h-1.5 bg-gold rounded-full animate-pulse" data-id="element-151" data-mp="2b0fxhhxomrcv" />
              OFERTA EXCLUSIVA PARA LATINOAMÉRICA
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="font-display text-4xl md:text-5xl lg:text-[52px] font-black leading-[1.15] mb-5 text-white" data-id="element-152" data-mp="2fzj2x3hkqzld">
              Deja de 'Intentar' Manifestar y Empieza a{' '}
              <span className="text-gradient" data-id="element-153" data-mp="umzh1s44xy5r">Reclamar la Vida</span>{' '}
              que te Pertenece por Derecho.
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="text-[15px] md:text-lg text-gray-400 leading-relaxed mb-9 max-w-[520px]" data-id="element-154" data-mp="zm2lpbg7e2d7">
              Activa tu frecuencia de abundancia con el sistema integral{' '}
              <strong className="text-white font-semibold" data-id="element-155" data-mp="9aql850ptotb">'Merezco la Vida de mis Sueños'</strong>.
              Reprograma tu mente subconsciente, elimina bloqueos de escasez
              y sintoniza con la riqueza en solo 30 días.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3
          }} className="flex flex-col gap-4 w-full md:w-auto" data-id="element-156" data-mp="3ct0nvl29gpiy">
              <a href="#oferta" className="inline-flex items-center justify-center gap-2.5 bg-gradient-to-br from-violet to-violet-dark text-white font-body text-base font-bold px-9 py-4.5 rounded-2xl shadow-[0_8px_32px_rgba(124,58,237,0.4)] hover:shadow-[0_12px_40px_rgba(124,58,237,0.6)] hover:-translate-y-0.5 transition-all relative overflow-hidden group w-full md:w-auto" data-id="element-157" data-mp="2yzj3xz5nxase">
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700 ease-in-out" data-id="element-158" data-mp="1eb6xd1vs3s60" />
                <ChevronRight className="w-5 h-5" data-id="element-159" data-mp="14h81gkmat4mi" />
                SÍ, QUIERO MI PACK DE ABUNDANCIA ($9.99)
              </a>
              
              <p className="flex items-center justify-center md:justify-start gap-2 text-[13px] text-gray-500" data-id="element-160" data-mp="1x76sglk1zbtt">
                <Check className="w-4 h-4 text-success" data-id="element-161" data-mp="1j7p05w7jtgfp" />
                Acceso inmediato · Pago 100% seguro · Garantía 7 días
              </p>
            </motion.div>
          </div>

          {/* Right Visual */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.4,
          duration: 0.8
        }} className="relative flex items-center justify-center mt-10 md:mt-0 order-first md:order-last" data-id="element-162" data-mp="7s0auy6to5bq">
            <div className="relative w-full max-w-[500px] mx-auto" data-id="element-163" data-mp="29ize98fifzm3">
              {/* Aura */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] rounded-full bg-[radial-gradient(ellipse,rgba(212,175,55,0.08)_0%,transparent_70%)] animate-pulse-slow pointer-events-none" data-id="element-164" data-mp="24q69wlnyetaj" />
              
              {/* Main Image Mockup */}
              <div className="relative z-10 rounded-2xl overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.5)] border border-gold/20 animate-float" data-id="element-165" data-mp="1qr6mtig3amgh">
                <img src="https://cdn.magicpatterns.com/uploads/tLF2WDbTfbN8zUUumDPvjh/Woman_in_silk_dress_collage_202607261445.jpeg_202608241740.jpg" alt="Merezco la Vida de mis Sueños - Edición Especial" className="w-full h-auto object-cover" data-id="element-166" data-mp="1gttjvfn031j7" />
              </div>

              {/* Floating Badges */}
              <div className="absolute top-4 -right-4 md:-right-8 bg-card border border-gold/20 rounded-lg px-4 py-2.5 text-[13px] font-semibold text-gold shadow-xl animate-float z-20" style={{
              animationDelay: '-2s'
            }} data-id="element-167" data-mp="3jmr2uoifw56s">
                📖 +3 Bonos Incluidos
              </div>
              <div className="absolute bottom-10 -left-4 md:-left-8 bg-card border border-success/30 rounded-lg px-4 py-2.5 text-[13px] font-semibold text-success shadow-xl animate-float z-20" style={{
              animationDelay: '-1s'
            }} data-id="element-168" data-mp="19j90ixhel1n">
                ✅ Acceso Inmediato
              </div>
            </div>
          </motion.div>

        </div>
      </div>
    </section>;
}